import React, { useState } from "react";
import { MedViewWrapper } from "./medViewer.style";
import { IoInformationCircleOutline } from "react-icons/io5";
import Viewer from "react-viewer";
import { apiCallHandler } from "../../../services/packslip.service";
import { CustomerService_NEW_URL } from "../../../redux/Url";
import { ELASTIC_SEARCHTYPE } from "../../../constants";
import { message } from "antd";

const MedViewer = ({ productCode }) => {
  const [visible, setVisible] = useState(false);
  const [imgData, setImgData] = useState([]);
  const fetchMedicineImages = () => {
    const url = `${CustomerService_NEW_URL}/fetchFromElasticSearch`;

    apiCallHandler({
      method: "GET",
      url,
      params: {
        isMultiSearch: false,
        elasticSearchType: ELASTIC_SEARCHTYPE.PRODUCT_CODE_SEARCH,
        searchString: productCode,
      },
      next: (response) => {
        if (response.data.hits) {
          let currElasticData = response.data.hits?.hits[0] ?? null;

          let currImgs =
            currElasticData?._source?.product_image_urls
              ?.split(",")
              ?.map((item) => {
                return {
                  src: item ?? "",
                  alt: "med_images",
                };
              }) || [];
          if (!currImgs.length) {
            message.info(`No images found `);
            return;
          }
          setImgData(currImgs);
          setVisible(true);
        }
      },
    });
  };

  return (
    <MedViewWrapper>
      <IoInformationCircleOutline
        size={20}
        color="#758694"
        onClick={fetchMedicineImages}
      />
      <Viewer
        className="viewer-section"
        visible={visible}
        noClose={false}
        onClose={() => setVisible(false)}
        images={imgData}
        container={null}
        activeIndex={0}
        defaultScale={1.2}
        minScale="1"
        maxScale="3"
        zoomSpeed="0.5"
        zIndex="10000"
      />
    </MedViewWrapper>
  );
};

export default MedViewer;
